/*
職種新規登録：職種カテゴリーの選択上限
*/
if($('.js-upper-imit3').length) {
  $(function () {
    checked();
    $('.js-upper-imit3 input').on('click',function() {
      checked();
    });
    function checked() {
      var checked_length = $('.js-upper-imit3 input:checked').length;
        // 選択上限は5つまで
        if (checked_length >= 3) {
          $('.js-upper-imit3 input:not(:checked)').prop('disabled', true);
        } else {
          $('.js-upper-imit3 input:not(:checked)').prop('disabled', false);
        }
    };
  });
};

// 希望条件・志向 企業から受け取りたいメッセージ requiredつけ外し
if(('.js-checkbox-edit-list').length) {
  $(function () {
    var checked_length = $('.js-checkbox-edit-list input:checked').length;
    $('.js-checkbox-edit-list .checkbox-edit-item').on('click',function() {
      if (checked_length) {
        $('.js-checkbox-edit-list input:not(:checked)').prop('required', false);
      }
    });
  });
}
// 希望条件・志向 企業から受け取りたいメッセージ
$(function(){
    $(document).on('change', 'input.checkbox-edit-input', function(){
      var value = $(this).val();
      if( value == 0) {
        $('.checkbox-edit-item.js-commitment').find('.checkbox-edit-input').prop('checked', false);
      }else{
        $('input.checkbox-edit-input[value="0"]').prop('checked', false);
      }
      var length = $('.js-checkbox-edit-list .js-commitment input:checked').length;
      if(length == 0) {
        $('input.checkbox-edit-input[value="0"]').prop('checked', true);
      }
    });
});